<template>
  <QuesCard
    :maxwidth="maxwidth"
    :ques="ques"
    :isEdit="isEdit"
    @quesDel="$emit('quesDel')"
  >
    <template slot="title">
      {{ ques.serial == null ? '' : ques.serial + '. ' }}數字題
    </template>
    <v-card-text class="text-start" slot="content">
      <template v-if="!isEdit">
        <div v-for="(name, idx) in ques.cnName.split(/\r?\n/)" :key="idx">{{ ques.serial == null ? '' : ques.serial + '. ' }}{{ name }}</div>
        <!-- 加上題號在非編輯狀態 -->
      </template>
      <v-textarea
        v-if="isEdit"
        outlined
        rows="1"
        label="題目內容"
        auto-grow
        v-model="ques.cnName"
        class="peter-text"
        v-on:click="checkDef()"
      ></v-textarea>
      <v-row class="mt-2 ml-0 pr-3">
        <v-file-input
          v-if="isEdit"
          chips
          filled
          class="pt-0"
          v-model="ques.headingFile"
          accept="image/*"
          @change="onImgChangeHeading($event)"
          label="File input"
        >
        </v-file-input>
      </v-row>
      <v-row>
        <v-col class="pa-0 text-center" >
          <!-- <v-img></v-img> 改成 <img> 來顯示圖片原始的最大尺寸 max-width控制不破圖 -->
          <img
            v-if="ques.questHeadingPic"
            :src="
              ques.questHeadingPic.startsWith('data')
                ? ques.questHeadingPic
                : $store.state.server + ques.questHeadingPic
            "
            style="max-width: 100%"
          />
        </v-col>
      </v-row>

      <v-row v-if="isEdit">
        <v-col cols="12" sm="3" md="2">
          <v-text-field
            dense
            label="最小值"
            v-model="ques.miniNum"
            :max="ques.maxiNum"
            outlined
            class="centered-input peter-text"
            type="number"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="2">
          <v-text-field
            dense
            label="最大值"
            v-model="ques.maxiNum"
            :min="ques.miniNum"
            outlined
            class="centered-input peter-text"
            type="number"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-text-field
        v-if="!isEdit"
        maxlength="20"
        v-model="ques.value"
        outlined
        class="centered-input mt-4 peter-text"
        type="number"
        :max="ques.maxiNum"
        :min="ques.miniNum"
        append-outer-icon="add"
        @click:append-outer="increment"
        prepend-icon="remove"
        @change="onChange"
        @click:prepend="decrement"
      ></v-text-field>
    </v-card-text>
  </QuesCard>
</template>

<script>
import QuesCard from './QuesCard'
export default {
  created() {
    // 給預設值
    if (this.ques.value === null) {
      this.ques.value = Math.ceil((this.ques.miniNum + this.ques.maxiNum) / 2)
    }
  },
  components: {
    QuesCard,
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    maxwidth: {
      type: Number,
      default: null,
    },
    ques: {
      type: Object,
      default: () => {
        return {
          title: '文字題',
          cnName: '數字題題目內容',
          length: 20,
          value: 3,
        }
      },
    },
  },
  computed: {
    QType() {
      return this.$store.state.QType
    },
  },
  methods: {
    onImgChangeHeading(file) {
      if (!file) {
        this.ques.questHeadingPic = null
      } else {
        var fileReader = new FileReader()
        fileReader.addEventListener('load', (e) => {
          this.ques.questHeadingPic = e.target.result
        })
        fileReader.readAsDataURL(file)
      }
    },
    // 不要讓填入的數字超過 max, min
    onChange() {
      let currentValue = parseInt(this.ques.value)
      if (currentValue > this.ques.maxiNum) {
        this.ques.value = this.ques.maxiNum
      } else if (currentValue < this.ques.miniNum) {
        this.ques.value = this.ques.miniNum
      }
    },
    increment() {
      if (this.ques.value === null) this.ques.value = this.ques.maxiNum
      let inc = parseInt(this.ques.value) + 1
      if (inc <= this.ques.maxiNum) {
        this.ques.value = inc
      }
    },
    decrement() {
      if (this.ques.value === null) this.ques.value = this.ques.miniNum
      let dec = parseInt(this.ques.value) - 1
      if (dec >= this.ques.miniNum) {
        this.ques.value = dec
      }
    },
    checkDef() {
      if (this.QType.NUMERIC.template.cnName === this.ques.cnName) {
        this.ques.cnName = ''
      }
    },
  },
}
</script>

<style lang="scss">
.thiscard {
  border-radius: 10px;
  cursor: grab;
}
.centered-input input {
  text-align: center !important;
}
</style>
